module.exports = __webpack_public_path__ + "assets/img/c6e2e966e145f77e3af66a963e43f4dd.svg";